export default "__VITE_PUBLIC_ASSET__abb50407__"